const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_women-economy/artifacts/p7si2gi8_shescan%20logo%20mark%20and%20nameOrangeFinal.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-white text-ink border-t border-line"
    >
      <div className="w-full max-w-none px-4 sm:px-8 lg:px-12 py-14 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="SheScan"
                className="h-14 w-auto object-contain"
              />
              <span className="font-sans font-semibold uppercase text-xs tracking-widest text-ink-soft">
                The Redirect
              </span>
            </div>
            <p className="mt-6 text-sm text-ink-soft max-w-md leading-relaxed">
              Consumer layer of the Women's Economy (WE) Framework. A
              point-of-purchase infrastructure that closes the ecosystem loop.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink-soft mb-4">
              Navigate
            </div>
            <ul className="space-y-3">
              {[
                ["problem", "The Problem"],
                ["product", "The Product"],
                ["showcase", "Showcase & Services"],
                ["extension", "Chrome Extension"],
                ["vision", "The Vision"],
                ["signup", "Get Started"],
              ].map(([id, label]) => (
                <li key={id}>
                  <a
                    href={`/#${id}`}
                    className="text-sm text-ink link-under"
                    data-testid={`footer-link-${id}`}
                  >
                    {label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="/investors"
                  className="text-sm text-brand-orange link-under font-mono uppercase tracking-[0.18em] text-[12px]"
                  data-testid="footer-link-investors"
                >
                  Investor Relations →
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  className="text-sm text-ink-soft link-under font-mono uppercase tracking-[0.18em] text-[12px] hover:text-brand-orange transition-colors"
                  data-testid="footer-link-privacy"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink-soft mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:hello@shescan.app"
                  className="link-under text-ink"
                >
                  hello@shescan.app
                </a>{" "}
                <span className="text-ink-soft">— general</span>
              </li>
              <li>
                <a
                  href="mailto:invest@shescan.app"
                  className="link-under text-ink"
                >
                  invest@shescan.app
                </a>{" "}
                <span className="text-ink-soft">— investor data room</span>
              </li>
              <li>
                <a
                  href="mailto:support@shescan.app"
                  className="link-under text-ink"
                >
                  support@shescan.app
                </a>{" "}
                <span className="text-ink-soft">— platform inquiries</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-line flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink-soft">
            © {new Date().getFullYear()} SheScan — Women's Economy Framework
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-ink-soft">
            Make every purchase count.
          </span>
        </div>
      </div>
    </footer>
  );
}
